import { ILogger } from "@tdp/common/telemetry";
import { IPeoplePickerReader, PeoplePickerFetchResult } from "./IPeoplePickerReader";
import { parseApiResponse } from "@tdp/core/util/parseApiResponse";
import { z } from "zod";
import { IPeoplePickerResponseSchema } from "./IPeoplePickerReader";
import { ApiFetchStatus } from "@tdp/common/constants";

export interface ITdpPeoplePickerService {
  logger: ILogger;
  apiFetch: typeof fetch;
}

export class TdpPeoplePickerService implements IPeoplePickerReader {
  private logger: ILogger;
  private apiFetch: typeof fetch;

  constructor({ apiFetch, logger }: ITdpPeoplePickerService) {
    this.apiFetch = apiFetch;
    this.logger = logger;
  }

  async readUsers(input: string): Promise<PeoplePickerFetchResult> {
    // intentionally fetching 10 users
    // to avoid hitting the API limit
    const response = await this.apiFetch(`/users/${input}/10`);
    const parsedResponse = await parseApiResponse({
      response: response,
      errorMessage: "Error getting user details",
      logger: this.logger,
      zodType: z.object({ value: z.array(IPeoplePickerResponseSchema) }),
    });
    return {
      type: parsedResponse.type,
      ...(parsedResponse.errorType && { errorType: parsedResponse.errorType }),
      response: parsedResponse?.data?.value || [],
      ...(parsedResponse.errorMessage && { errorMessage: parsedResponse.errorMessage }),
    }
  }
}